import React from 'react';
import {Header,Item, Label,  Breadcrumb, Table, Transition, Icon, Segment, Container, Loader, Dropdown, Divider, Form, Dimmer, Button, Grid,Input, Radio, Popup, List} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import moment from 'moment';



const ReporteCurso=({ id, ajaxCallInProgress, errors=[], reporte, strings, cursoCombo, onChange, consultar, registros, reporteTipo, pagoReporte, constancias, examen})=>{
    
    console.log(registros);
    console.log(pagoReporte);
    console.log(constancias);
    console.log(examen);
    
    
	return (
        <Container>
            
            <Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form >
                
                            <Form.Field  required  error={errors.cursoId}>
                              <label  >{strings?strings["Curso"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["Curso"]:""} 
                                    name="cursoId"
                                     fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={reporte.cursoId}
                                    options={cursoCombo}/>
                            </Form.Field>
        
                              <Form.Field  required  error={errors.reporteTipo}>
                              <label  >{strings?strings["reporteTipo"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["reporteTipo"]:""} 
                                    name="reporteTipo"
                                     fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={reporte.reporteTipo}
                                    options={reporteTipo}/>
                            </Form.Field>
                           
                         </Form>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column  textAlign="center">
        
                            <Button.Group  >
               
                            <Button  color="black"
                                onClick={consultar}>{strings?strings["consultar"]:""}
                             </Button>
                            </Button.Group>
            
                    </Grid.Column>
                </Grid.Row>
                
            </Grid>
            
        
        { registros.inscripcion!=null &&  registros.inscripcion.length>0?
            <Container>
                <br/><br/>
                <Segment clearing>
                    <Header floated='left'>
                       Alumnos inscritos: {registros.inscripcion.length}
                    </Header>

                  </Segment>

                <Table celled>
                    <Table.Header>
                    <Table.Row>

                            <Table.HeaderCell>{strings?strings["alumno"]:""}</Table.HeaderCell>
                            <Table.HeaderCell>{strings?strings["profesion"]:""}</Table.HeaderCell>
                            <Table.HeaderCell>{strings?strings["mail"]:""}</Table.HeaderCell>
                            <Table.HeaderCell>{strings?strings["pais"]:""}</Table.HeaderCell>
                            <Table.HeaderCell>{strings?strings["empresa"]:""}</Table.HeaderCell>
                            <Table.HeaderCell>{strings?strings["roll"]:""}</Table.HeaderCell>
                            <Table.HeaderCell>{strings?strings["telefono"]:""}</Table.HeaderCell>
                            <Table.HeaderCell textAlign="center">{strings?strings["modulosVistos"]:""}</Table.HeaderCell>


                    </Table.Row>
        
                    {registros.inscripcion.map(alumno =>
                            
                            <Table.Row>
                                    <Table.Cell>
                                        {alumno.usuario}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {alumno.profesion}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {alumno.mail}
                                    </Table.Cell>    
                                    <Table.Cell >
                                        {alumno.pais}
                                    </Table.Cell>    
                                    <Table.Cell >
                                        {alumno.empresa}
                                    </Table.Cell>
                                    <Table.Cell >
                                        {alumno.roll}
                                    </Table.Cell>
                                    <Table.Cell textAlign="right">
                                        {alumno.telefono}
                                    </Table.Cell>    
                                    <Table.Cell textAlign="center">
                                    {((Number(alumno.modulosVistos)*100)/Number(registros.modulos)).toFixed(0)}%
                                    </Table.Cell>
                                 
                                  
                            </Table.Row>    
                            
                            )}
        
        
        
                
        
        
                    </Table.Header>

                </Table>



            </Container>
        :
            ""
        }
        
        
        <Container>
        {pagoReporte!=null &&  pagoReporte.length>0?
         
        
            
            <>
            <br/><br/>
            <Table  celled >
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>{strings?strings["alumno"]:""}</Table.HeaderCell>
                        <Table.HeaderCell>{strings?strings["mail"]:""}</Table.HeaderCell>
                        <Table.HeaderCell>{strings?strings["telefono"]:""}</Table.HeaderCell>
                        <Table.HeaderCell>{strings?strings["fecha"]:""}</Table.HeaderCell>
                        <Table.HeaderCell>{strings?strings["monto"]:""}</Table.HeaderCell>    
                        <Table.HeaderCell>{strings?strings["estatus"]:""}</Table.HeaderCell>    
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {pagoReporte.map(pago =>
								<Table.Row>
                                    <Table.Cell>{pago.alumno}</Table.Cell>
                                    <Table.Cell>{pago.correo}</Table.Cell>
                                    <Table.Cell>{pago.telefono}</Table.Cell>
                                    <Table.Cell>{pago.fechaPago}</Table.Cell>  
                                    <Table.Cell>{pago.montoPago}</Table.Cell>
                                    <Table.Cell textAlign="center">
                                        <List.Item>
                                        <Popup
                                            trigger={
                                                <Icon name={pago.atrasado==1?'circle':'circle'} link  size="large" 
                                                    color={pago.atrasado==1?"red":"green"}  

                                                />
                                            }
                                            content={pago.atrasado==1?'Atrasado':'En tiempo'}
                                          />  




                                        </List.Item>
                                    </Table.Cell>
                                </Table.Row>
				        )}	
                    </Table.Body>
                  </Table> 
            </>      
                    
            :
            
            ""
        }
        
        </Container>
        
        
        
        <Container>
        {constancias!=null &&  constancias.length>0?
         
        
            <>
            <br/><br/>
            <Table  celled >
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>{strings?strings["alumno"]:""}</Table.HeaderCell>
                        <Table.HeaderCell>{strings?strings["mail"]:""}</Table.HeaderCell>
                        <Table.HeaderCell>{strings?strings["emision"]:""}</Table.HeaderCell>
   
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {constancias.map(constancia =>
								<Table.Row>
                                    <Table.Cell>{constancia.nombre}</Table.Cell>
                                    <Table.Cell>{constancia.mail}</Table.Cell>
                                    <Table.Cell>{constancia.emisionConstancia}</Table.Cell>
                                 
                                </Table.Row>
				        )}	
                    </Table.Body>
                  </Table> 
            </>    
                    :""
        }
        
        </Container>
        
        
        
        <Container>
        {examen!=null &&  examen.length>0?
            <>
            <br/><br/>
            <Table  celled >
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>{strings?strings["alumno"]:""}</Table.HeaderCell>
                        <Table.HeaderCell>{strings?strings["mail"]:""}</Table.HeaderCell>
                        <Table.HeaderCell>{strings?strings["empresa"]:""}</Table.HeaderCell>
                        <Table.HeaderCell>{strings?strings["examen"]:""}</Table.HeaderCell>
                        <Table.HeaderCell>{strings?strings["preguntas"]:""}</Table.HeaderCell>
                        <Table.HeaderCell>{strings?strings["respuestasCorrectas"]:""}</Table.HeaderCell>
                        <Table.HeaderCell>{strings?strings["calificacion"]:""}</Table.HeaderCell>
   
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {examen.map(datos =>
								<Table.Row>
                                    <Table.Cell>{datos.usuario}</Table.Cell>
                                    <Table.Cell>{datos.mail}</Table.Cell>
                                    <Table.Cell>{datos.empresa}</Table.Cell>
                                    <Table.Cell>{datos.nombreFormulario}</Table.Cell>
                                    <Table.Cell textAlign="right">{datos.numberOfQuestions}</Table.Cell>
                                    <Table.Cell textAlign="right">{datos.numberOfCorrectAnswers}</Table.Cell>
                                    <Table.Cell textAlign="right">{Number(datos.numberOfCorrectAnswers*(10/datos.numberOfQuestions)).toFixed(2)}</Table.Cell>
                                 
                                </Table.Row>
				        )}	
                    </Table.Body>
                  </Table> 
            </>        
                    
                :""    
        }
        
        </Container>
        
        
        
        
        </Container>
	);
};



export default ReporteCurso;